import React, { Component } from "react";
import styled from "react-emotion";
import { connect } from "react-redux";

import DesktopPreview from "./DesktopPreview";
const imgSrc = require("../../images/950x350-ucla-blue-solid-color-background.jpg");
let index = 0;

// -------------------------------- Styles --------
const PreviewContainer = styled("div")({
  position: "relative",
  width: "70%"
});

class BannerPreview extends Component {
  state = {
    selectedObject: {
      headline: "Headline",
      description: "Description",
      businessName: "Business name",
      selectedImage: {
        url: imgSrc
      },
      selectedLogo: {
        url: ""
      }
    },
    loading: false
  };

  componentWillReceiveProps(nextProps) {
    if (index === 0)
      this.setState({
        selectedObject: nextProps.previewInfo[0]
      });
  }

  render() {
    const { previewInfo } = this.props;
    return (
      <PreviewContainer className="previewContainer">
        <DesktopPreview previewInfo={previewInfo} />
      </PreviewContainer>
    );
  }
}

const mapStateToProps = state => ({
  previewInfo: state.previewImages
});

export default connect(mapStateToProps)(BannerPreview);
